import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { graphlib } from '@dagrejs/dagre';
import { ENUM__field_graph_interaction } from '@shared/dto/generation/graph_invoke/_fields/_base/_enums/ENUM__field_graph_interaction';
import { ENUM__field_connectable_type } from '@shared/dto/generation/graph_invoke/_fields/_base/_methods/ENUM__field_connectable_type';
import { FN_FIELD__fields_types_are_compatible } from '@shared/dto/generation/graph_invoke/_fields/_base/_methods/FN_FIELD__fields_types_are_compatible';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD__list_base_generic } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_base_generic';
import { Position } from '@xyflow/react';

export function HOOK__handle_is_connectable_base(field_this: FIELD__base) {
  const { g_graph__new_edge_field, g_graph__new_edge_field_position } = use_slice_ui(['g_graph__new_edge_field', 'g_graph__new_edge_field_position']);

  const { generation_current } = use_slice_generation(['generation_current']);
  const { meta } = field_this;

  let { graph } = generation_current.tool;

  /*
   *
   */

  let field_other = g_graph__new_edge_field;

  const position_selected = g_graph__new_edge_field_position;
  const is_selected_handle_left = position_selected == Position.Left;
  const is_selected_handle_right = position_selected == Position.Right;

  /*
   * METHODS
   */
  function is_connection_does_cycles() {
    if (g_graph__new_edge_field.is_stub()) return false;

    let graph_dagre = graph.dagre__convert_to();

    graph_dagre.setEdge(g_graph__new_edge_field.meta.field_id, meta.field_id);

    return !graphlib.alg.isAcyclic(graph_dagre);
  }

  function is_connectable_by_type() {
    let are_types_compatible = FN_FIELD__fields_types_are_compatible(field_other, field_this);

    if (!are_types_compatible) return false;

    let out: boolean;

    let type_this = field_this.field_connectable__type();
    let type_other = field_other.field_connectable__type();

    let this_is_list = type_this == ENUM__field_connectable_type.LIST;
    let other_is_list = type_other == ENUM__field_connectable_type.LIST;

    let from_other_item_to_this_list = this_is_list && !other_is_list;
    let from_other_list_to_this_item = !this_is_list && other_is_list;

    if (is_selected_handle_right) {
      //connection SELECTED OTHER RIGHT -> THIS LEFT
      //
      if (from_other_list_to_this_item) {
        //SELECTED OTHER list -> THIS item
        out = false;
      } else {
        out = are_types_compatible && field_this.meta.data__synced_by_parent_id.is_empty_uuid();
      }
    } else {
      //connection THIS RIGHT <- SELECTED OTHER LEFT
      //
      if (from_other_item_to_this_list) {
        //THIS list <- SELECTED OTHER item
        out = false;
      } else {
        out = are_types_compatible && field_other.meta.data__synced_by_parent_id.is_empty_uuid();
      }
    }

    return out;
  }

  function is_list_restricted_to_connect(field: FIELD__base, need_to_check: boolean) {
    if (!(field instanceof FIELD__list_base_generic)) return false;
    if (!need_to_check) return false;

    return !field.buttons_add_remove_are_disabled;
  }

  let field_other_source = field_other.find_source(graph);
  let field_this_source = field_this.find_source(graph);

  /*
   * RESULT
   */

  if (field_this.is_stub()) return false;
  if (field_other.meta.is_stub()) return true; //non handle selected
  //
  if (field_this.meta.grid2d__is_dimension) return false;
  if (field_other.meta.grid2d__is_dimension) return false;
  //
  if (field_this.meta.graph__interaction != ENUM__field_graph_interaction.VISIBLE_CONNECTABLE) return false;
  if (field_other.meta.node_id == meta.node_id) return false; //cant connect to self
  if (is_selected_handle_right && meta.ui__is_readonly && meta.kind__is_input) return false; //cant connect to readonly input field from left side
  if (is_selected_handle_right && meta.kind__is_output) return false; //cant connect to outputs from left side
  if (!is_connectable_by_type()) return false;
  if (!field_other_source.is_field_is_compatible_to_sync_with(field_this_source)) return false;
  if (graph.edge__already_exists__for_fields(field_this, field_other)) return false;
  if (is_connection_does_cycles()) return false;

  return true;
}
